export const postData = async (data: { [key: string]: number | string }, url: string) => {
	const endpoint = `${url}/create-post`;

	const response = await fetch(endpoint, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	});

	if (!response.ok) {
		const errorData = await response.json();
		throw new Error(errorData.error || 'Failed to post data');
	}

	const result = await response.json();
	return result;
};
